import "../../styles/Shipment.css";

const ShippingBanner = () => {
  return (
    <section className="shipping-banner">
      <div className="shipping-banner__content">
        <h1>
          “We Are Expanding India's legacy of
          <br />
          Quality With Every Shipment.”
        </h1>
      </div>
    </section>
  );
};

export default ShippingBanner;
